import React from 'react';

const variants = {
  primary: {
    background: 'var(--color-gradient)',
    color: 'var(--color-white)',
    border: 'none',
    boxShadow: 'var(--shadow-sm)',
  },
  secondary: {
    backgroundColor: 'var(--color-primary-light)',
    color: 'var(--color-primary)',
    border: '1px solid var(--color-primary)',
  },
  danger: {
    backgroundColor: 'var(--color-danger)',
    color: 'var(--color-white)',
    border: 'none',
  },
  ghost: {
    backgroundColor: 'transparent',
    color: 'var(--color-text-secondary)',
    border: '1px solid var(--color-border)',
  },
};

const sizes = {
  sm: { padding: '6px 12px', fontSize: 'var(--font-size-sm)' },
  md: { padding: '10px 20px', fontSize: 'var(--font-size-base)' },
  lg: { padding: '12px 24px', fontSize: 'var(--font-size-md)' },
};

export default function Button({
  children, onClick, variant = 'primary', size = 'md',
  disabled = false, loading = false, style, type = 'button', fullWidth = false,
  ...rest
}) {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      {...rest}
      style={{
        ...variants[variant] || variants.primary,
        ...sizes[size] || sizes.md,
        borderRadius: 'var(--radius-md)',
        fontWeight: '600',
        cursor: disabled || loading ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.6 : 1,
        width: fullWidth ? '100%' : undefined,
        transition: 'var(--transition-bounce)',
        ...style,
      }}
    >
      {loading ? 'جاري التحميل...' : children}
    </button>
  );
}
